import { serialize, parse } from "cookie";
import { GetServerSideProps } from "next";

import { COOKIES } from "~/constant/cookies";
import { HEADERS } from "~/constant/headers";
import { ROUTES } from "~/constant/routes";
import { BasePage } from "~/layouts/base-page";
import { OnboardingPage } from "~/layouts/onboarding-page";
import { CreatorLogin } from "~/modules/auth/creator-login";
import { AuthQueries } from "~/modules/auth/queries";
import { getNakedDomain } from "~/utils/url-utils";

const LoginPage = ({ isMagicLinkInvalid }: { isMagicLinkInvalid?: boolean }) => {
  return (
    <BasePage title="Log in">
      <OnboardingPage>
        <CreatorLogin isMagicLinkInvalid={isMagicLinkInvalid} />
      </OnboardingPage>
    </BasePage>
  );
};

export const getServerSideProps: GetServerSideProps<{ isMagicLinkInvalid?: boolean }> = async (context) => {
  const magicToken = parse(context.req.headers.cookie ?? "")?.[COOKIES.HEADOUT_AUTH_TOKEN];

  if (magicToken) {
    try {
      const response = await AuthQueries.verifyMagicLinkToken(magicToken);
      const nakedDomain = getNakedDomain(context.req?.headers?.host || "");

      const loginCookieTracker = serialize(COOKIES.LOGIN_COOKIE_TRACKER, "true", {
        path: "/",
        domain: nakedDomain,
        secure: false,
        httpOnly: false,
      });

      const cookie = serialize(COOKIES.CREATOR_AUTH_TOKEN, response.token, {
        path: "/",
        domain: nakedDomain,
        sameSite: "none",
        secure: true,
        httpOnly: true,
        // expires in 7 days
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      });

      context.res.setHeader(HEADERS.SET_COOKIE, [cookie, loginCookieTracker]);

      return {
        redirect: {
          destination: ROUTES.CREATOR_OPPORTUNITIES,
          permanent: true,
        },
        props: {
          isMagicLinkInvalid: false,
        },
      };
    } catch (e) {
      return {
        props: {
          isInvalidMagicLink: true,
        },
      };
    }
  }

  // Pass data to the page via props
  return {
    props: {
      isMagicLinkInvalid: false,
    },
  };
};

export default LoginPage;
